import { Button } from '@dfh-corp-sites/ui'
import React, { FC, useEffect, useRef } from 'react'
import { useReactToPrint } from 'react-to-print'

import Modal from '../../Modal'

export interface TestKitLegalTermsModalProps {
  isOpen: boolean
  closeModal: () => void
}

export const TestKitLegalTermsModal: FC<TestKitLegalTermsModalProps> = ({ isOpen, closeModal }) => {
  const descriptionElementRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (isOpen) {
      const { current: descriptionElement } = descriptionElementRef
      if (descriptionElement !== null) {
        descriptionElement.focus()
      }
    }
  }, [isOpen])

  const handlePrint = useReactToPrint({
    content: () => descriptionElementRef.current,
  })

  return (
    <Modal
      onClose={closeModal}
      isOpen={isOpen}
      maxWidth="md"
      cta={
        <Button
          onClick={handlePrint}
          variant="text"
          className="mr-auto font-bold text-brand-orange"
        >
          Print
        </Button>
      }
    >
      <div className="text-sm text-brand-navy print:p-4" ref={descriptionElementRef} tabIndex={-1}>
        <h3 className="text-2xl text-brand-navy font-semibold mb-8">Ordering Clinician Policy</h3>
        <p>
          This Ordering Clinician Policy is an agreement (&quot;Agreement&quot;) between me and
          Designs for Health, Inc. (&quot;DFH&quot;) regarding each GI Spotlight&trade;, Genomic
          Spotlight&trade;, Metabolomics Spotlights&trade;, or other functional wellness test
          analysis program that is offered for sale now or in the future by DFH program
          (&quot;Program&quot;) and purchased, added to an eScript, or otherwise made available
          (collectively, &quot;Provided&quot;) for use by any person other than me (each a
          &quot;Customer&quot;). To the extent required by applicable law:
        </p>
        <br />
        <ol className="list-decimal pl-6">
          <li>
            I will not Provide any Program to a Customer unless the Customer gives informed consent
            and receives sufficient notice regarding the collection, use, retention, or disclosure
            of the Customer’s test results or other personal information;
          </li>
          <li>
            I will satisfy any legally binding requests by the Customer to access, correct, or
            otherwise act on the Customer&apos;s personal information associated with the Program,
            seeking DFH&apos;s assistance if necessary; and
          </li>
          <li>
            DFH may, but is not required to, respond directly to any such requests it receives, in
            which case it will attempt to notify me.
          </li>
        </ol>
        <br />
        <p>
          If any person or business employs me or otherwise uses my services in the process of
          Providing Programs to Customers (my &quot;Employer&quot;), then I accept this Agreement
          also on my Employer&apos;s behalf and warrant I am legally authorized to do so.
        </p>
      </div>
    </Modal>
  )
}
